// components/connector/navigation.tsx
import React from "react";
import { ChevronLeft } from "lucide-react";

interface NavigationProps {
  currentStep: number;
  onBack: () => void;
  onContinue: () => void;
  onSubmit: () => void;
  canProceed: any;
  isLastStep: boolean;
  submitting?: boolean;
  // Once the real create call has already succeeded, hide the submit button
  // entirely rather than leaving it clickable (a second click would create a
  // duplicate connection) — the page's own success UI takes over from there.
  submitted?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({
  currentStep,
  onBack,
  onContinue,
  onSubmit,
  canProceed,
  isLastStep,
  submitting = false,
  submitted = false,
}) => {
  return (
    <div className="flex justify-between items-center mt-12 pt-6 border-t border-gray-200 dark:border-gray-800">
      <button
        onClick={onBack}
        className="flex items-center space-x-2 px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
      >
        <ChevronLeft className="h-4 w-4" />
        <span>{currentStep === 1 ? "Back to Connections" : "Back"}</span>
      </button>

      {!isLastStep ? (
        <button
          onClick={onContinue}
          disabled={!canProceed}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 disabled:bg-gray-300 dark:disabled:bg-gray-700 disabled:cursor-not-allowed"
        >
          Continue
        </button>
      ) : !submitted ? (
        <button
          onClick={onSubmit}
          disabled={!canProceed || submitting}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 disabled:bg-gray-300 dark:disabled:bg-gray-700 disabled:cursor-not-allowed"
        >
          {submitting ? "Creating…" : "Create Connection"}
        </button>
      ) : null}
    </div>
  );
};